import './startOverPopup.scss';

import { Popup } from '@approvalmax/ui';
import { selectors, ui } from 'modules/common';
import { State } from 'modules/data';
import { useShallowEqualSelector } from 'modules/react-redux';
import { memo, useState } from 'react';
import bemFactory from 'react-bem-factory';
import { useDispatch } from 'react-redux';

import { startOverRequest } from '../actions';
import { StartOverPopupData } from '../reducers/page/activePopup/startOverPopupReducer';
import { getActivePopup, isActiveRequestLocked } from '../selectors/pageSelectors';
import { messages } from './StartOverPopup.messages';

const bem = bemFactory.block('reql-start-over-popup');
const qa = bemFactory.qa('reql-start-over-popup');

const StartOverPopup = () => {
    const [commentText, setCommentText] = useState('');
    const dispatch = useDispatch();
    const { request, isLocked } = useShallowEqualSelector((state: State) => {
        const { requestId } = getActivePopup<StartOverPopupData>(state);
        const request = selectors.request.getRequestById(state, requestId);

        return {
            request,
            isLocked: isActiveRequestLocked(state),
        };
    });

    const onDone = () => {
        dispatch(startOverRequest(request, commentText));
    };

    return (
        <Popup.DefaultContent
            className={bem()}
            qa={qa()}
            title={messages.popupTitle}
            buttons={
                <Popup.DefaultContent.Button
                    qa={qa('done-button')}
                    disabled={isLocked}
                    execute={onDone}
                    title={messages.startOverButtonTitle}
                >
                    {messages.startOverButtonText}
                </Popup.DefaultContent.Button>
            }
        >
            <div className={bem('content')}>
                <div className={bem('description')}>{messages.descriptionText({ br: <br /> })}</div>

                <ui.AddCommentEditor
                    focusOnMount
                    className={bem('comment-editor')}
                    qa={qa('comment-editor')}
                    value={commentText}
                    onChange={setCommentText}
                />
            </div>
        </Popup.DefaultContent>
    );
};

export default memo(StartOverPopup);
